import api from 'api';
import { useEffect, useState } from 'react';
import 'styles/quotegroup.css';

const Group = (
    {
        group,
        setReloadGroup,
    }
) => {

    // gère la modification du groupe
    const handleClickM = () => {
        // eslint-disable-next-line no-restricted-globals
        const response = prompt("Nouveau nom du groupe");
        if (response===null || response==='') return;
        api.put(`group/${group.id}/update`, {
            name : response,
            quote : group.quote
        })
        .then((response) => {
            setReloadGroup(true);
        });
        
    };
    
    // gère la suppression du groupe
    const handleClickD = () => {
        // eslint-disable-next-line no-restricted-globals
        const response = confirm("Êtes-vos sûr de vouloir supprimer ce groupe ?");
        if (!response) return;
        api.delete(`group/${group.id}/del`)
        .then((response) => {
            setReloadGroup(true);
        });
        
    };
    
    return (
        <div
            className='QuoteGroupLine'
        >
            <div>
                {group.name}
            </div>
            <div
                className='QuoteGroupLineButton'
                onClick={handleClickM}
            >
                ✎
            </div>
            <div
                className='QuoteGroupLineButton'
                onClick={handleClickD}
            >
                🗑️
            </div>
        </div>
    )
};


const QuoteGroup = (
    {
        quoteid, // id pour devis sélectionné
        groups,
        setGroups,
        setGroup,
    }
) => {
    
    const [ reloadGroup, setReloadGroup ] = useState(true); // rechargement des groupes

    // récupère la liste des groupes
    useEffect(()=>{
        if (reloadGroup) {
            api.get(`quote/${quoteid}/groups`)
            .then((response)=>{
                setReloadGroup(false);
                if (response.data.length===0) {
                    setGroup(null);
                }
                if (response.data.length===1) {
                    setGroup(response.data[0])
                }
                setGroups(response.data);
            })
        }
    },[reloadGroup, quoteid, setGroups, setReloadGroup, setGroup]);

    // gère l'ajout d'un groupe
    const handleClick = () => {
        // eslint-disable-next-line no-restricted-globals
        const response = prompt("Nom du nouveau groupe");
        if (response===null || response==='') return;
        api.post(`group/add`, {
            name : response,
            quote : quoteid
        })
        .then((response) => {
            setReloadGroup(true);

        });
    };
    
    return (
        <div
            className="QuoteGroup"
        >
            GROUPES
            <div
                className='QuoteGroupAdd'
                onClick={handleClick}
            >
                +
            </div>
            {
                groups
                &&
                groups.map((group) => <Group
                    key={group.id}
                    group={group}
                    setReloadGroup={setReloadGroup}
                    setGroup={setGroup}
                />)
            }
        </div>
    );
};

export default QuoteGroup;